import { FormFieldConfig } from '@shared/components/search-form/search-form.component';
import { TableColumn } from '@shared/components/data-table/data-table.component';

export const TAX_CATEGORY_DEFAULT_COLUMNS = {
  TAX_CODE: 'taxCode',
  TAX_NAME: 'taxName',
  TAX_RATE: 'taxRate',
  ACTIVE_FLAG: 'activeFlag',
  EFFECTIVE_FROM: 'effectiveFrom',
  EFFECTIVE_TO: 'effectiveTo',
  REMARK: 'remark',
} as const;

export const TAX_CATEGORY_ACTION_COLUMN = {
  ACTIONS: 'actions',
} as const;

export const TAX_CATEGORY_DEFAULT_COLUMNS_ORDER: string[] = [
  TAX_CATEGORY_DEFAULT_COLUMNS.TAX_CODE,
  TAX_CATEGORY_DEFAULT_COLUMNS.TAX_NAME,
  TAX_CATEGORY_DEFAULT_COLUMNS.TAX_RATE,
  TAX_CATEGORY_DEFAULT_COLUMNS.ACTIVE_FLAG,
  TAX_CATEGORY_DEFAULT_COLUMNS.EFFECTIVE_FROM,
  TAX_CATEGORY_DEFAULT_COLUMNS.EFFECTIVE_TO,
  TAX_CATEGORY_DEFAULT_COLUMNS.REMARK,
];

export const TAX_CATEGORY_FLEXIBLE_COLUMNS_ORDER: string[] = [];

export const TAX_CATEGORY_COLUMNS: TableColumn[] = [
  {
    label: 'settings.product.tax_categories.fields.tax_code',
    prop: TAX_CATEGORY_DEFAULT_COLUMNS.TAX_CODE,
    width: 140,
  },
  {
    label: 'settings.product.tax_categories.fields.tax_name',
    prop: TAX_CATEGORY_DEFAULT_COLUMNS.TAX_NAME,
    width: 180,
  },
  {
    label: 'settings.product.tax_categories.fields.tax_rate',
    prop: TAX_CATEGORY_DEFAULT_COLUMNS.TAX_RATE,
    width: 110,
    type: 'custom',
  },
  {
    label: 'settings.product.tax_categories.fields.active',
    prop: TAX_CATEGORY_DEFAULT_COLUMNS.ACTIVE_FLAG,
    width: 120,
    type: 'custom',
  },
  {
    label: 'settings.product.tax_categories.fields.effective_from',
    prop: TAX_CATEGORY_DEFAULT_COLUMNS.EFFECTIVE_FROM,
    width: 140,
    type: 'custom',
  },
  {
    label: 'settings.product.tax_categories.fields.effective_to',
    prop: TAX_CATEGORY_DEFAULT_COLUMNS.EFFECTIVE_TO,
    width: 140,
    type: 'custom',
  },
  {
    label: 'settings.product.tax_categories.fields.remark',
    prop: TAX_CATEGORY_DEFAULT_COLUMNS.REMARK,
    width: 220,
  },
  {
    label: 'settings.product.tax_categories.fields.actions',
    prop: TAX_CATEGORY_ACTION_COLUMN.ACTIONS,
    type: 'actions',
    width: 220,
  },
];

export function buildTaxCategorySearchConfig(): FormFieldConfig[] {
  return [
    {
      key: 'taxCode',
      label: 'settings.product.tax_categories.fields.tax_code',
      type: 'text',
      placeholder: 'settings.product.tax_categories.placeholders.tax_code',
      showClear: true,
    },
    {
      key: 'taxName',
      label: 'settings.product.tax_categories.fields.tax_name',
      type: 'text',
      placeholder: 'settings.product.tax_categories.placeholders.tax_name',
      showClear: true,
    },
    {
      key: 'activeFlag',
      label: 'settings.product.tax_categories.fields.active',
      type: 'select',
      placeholder: 'common.form.placeholders.select',
      showClear: true,
      options: [
        {
          label: 'settings.product.tax_categories.status.active',
          value: true,
        },
        {
          label: 'settings.product.tax_categories.status.inactive',
          value: false,
        },
      ],
    },
    {
      key: 'effectiveAt',
      label: 'settings.product.tax_categories.fields.effective_at',
      type: 'dateRange',
      range: {
        startKey: 'effectiveAt',
        endKey: 'unusedEffectiveAtEnd',
      },
    },
  ];
}
